<template>
  <div class="g-container-box">
    <el-row class="g-header-container">
      <el-col :span="3">
        <div class="g-header-left">熟客控制台</div>
      </el-col>
      <el-col :span="16">
        <nav-head navSel="2"></nav-head>
      </el-col>
      <el-col :span="5">
        <op-head></op-head>
      </el-col>
    </el-row>

    <el-row class="g-view-container">
      <el-col :span="3" class="g-menu-container">
        <sidebar defaultSel="2"></sidebar>
      </el-col>

      <el-col :span="21" class="g-center-container">
        <div class="stats-page">
          <el-tabs v-model="activeTab" class="stats-tabs">
            <el-tab-pane label="实时概况" name="overview">
              <el-row :gutter="20" class="overview-card-row">
                <el-col
                  v-for="(item, index) in summaryCards"
                  :key="index"
                  :span="summaryCards.length === 3 ? 8 : 6"
                >
                  <div class="overview-card">
                    <div class="overview-card__icon" :class="'icon-bg-' + index">
                      <i :class="item.icon"></i>
                    </div>
                    <div class="overview-card__content">
                      <div class="overview-card__label">{{ item.label }}</div>
                      <div class="overview-card__value">{{ item.value }}</div>
                      <div class="overview-card__desc">{{ item.desc }}</div>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="table-card">
                <div class="table-card__header">
                  <div class="table-card__title">数据汇总</div>
                  <div class="table-card__sub">统计维度：合计 / 昨日 / 一周内 / 近30日</div>
                </div>

                <el-table
                  :data="overviewTable"
                  border
                  stripe
                  v-loading="loading"
                  element-loading-text="数据加载中..."
                  class="overview-table"
                  empty-text="暂无统计数据"
                >
                  <el-table-column
                    prop="timeLabel"
                    label="时间"
                    min-width="120"
                    align="center"
                  ></el-table-column>

                  <el-table-column
                    prop="userCount"
                    label="注册用户数"
                    min-width="160"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ formatNumber(scope.row.userCount) }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="shopCount"
                    label="入驻门店数"
                    min-width="160"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ formatNumber(scope.row.shopCount) }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    v-if="showMerchantColumn"
                    prop="merchantCount"
                    label="入驻电商数"
                    min-width="160"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ formatNumber(scope.row.merchantCount) }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="uv"
                    label="日均访客数（UV）"
                    min-width="180"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ formatNumber(scope.row.uv) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
var util = require("@/common/util.js");

import { API_MSHZTJ } from "../../assets/js/api.js";
import sidebar from "../../components/sidebar.vue";
import navHead from "../../components/navHead.vue";
import opHead from "../../components/opHead.vue";

export default {
  name: "statisticsPage",
  components: {
    sidebar,
    navHead,
    opHead,
  },
  data() {
    return {
      activeTab: "overview",
      loading: false,
      summaryCards: [],
      overviewTable: [],
      showMerchantColumn: false,
    };
  },
  created() {
    this.getListData();
  },
  methods: {
    getListData() {
      this.loading = true;

      util.postData(
        API_MSHZTJ,
        {},
        (res) => {
          const data = res && res.data && res.data.data ? res.data.data : {};

          const total = this.normalizeSection(data.total || {});
          const yesterday = this.normalizeSection(data.yesterday || {});
          const week = this.normalizeSection(data.last7Days || {});
          const month = this.normalizeSection(data.last30Days || {});

          this.showMerchantColumn =
            this.hasMerchantField(data.total) ||
            this.hasMerchantField(data.yesterday) ||
            this.hasMerchantField(data.last7Days) ||
            this.hasMerchantField(data.last30Days);

          this.summaryCards = this.buildSummaryCards(total);

          this.overviewTable = [
            {
              timeLabel: "合计",
              userCount: total.userCount,
              shopCount: total.shopCount,
              merchantCount: total.merchantCount,
              uv: total.uv,
            },
            {
              timeLabel: "昨日",
              userCount: yesterday.userCount,
              shopCount: yesterday.shopCount,
              merchantCount: yesterday.merchantCount,
              uv: yesterday.uv,
            },
            {
              timeLabel: "一周内",
              userCount: week.userCount,
              shopCount: week.shopCount,
              merchantCount: week.merchantCount,
              uv: week.uv,
            },
            {
              timeLabel: "近30日",
              userCount: month.userCount,
              shopCount: month.shopCount,
              merchantCount: month.merchantCount,
              uv: month.uv,
            },
          ];

          this.loading = false;
        },
        "application/json"
      );
    },

    buildSummaryCards(total) {
      const cards = [
        {
          label: "注册用户总数",
          value: this.formatNumber(total.userCount),
          desc: "当前累计注册用户",
          icon: "el-icon-user",
        },
        {
          label: "入驻门店总数",
          value: this.formatNumber(total.shopCount),
          desc: "当前累计入驻门店",
          icon: "el-icon-office-building",
        },
      ];

      if (this.showMerchantColumn) {
        cards.push({
          label: "入驻电商总数",
          value: this.formatNumber(total.merchantCount),
          desc: "当前累计入驻电商",
          icon: "el-icon-s-shop",
        });
      }

      cards.push({
        label: "日均访客数",
        value: this.formatNumber(total.uv),
        desc: "整体UV表现",
        icon: "el-icon-data-line",
      });

      return cards;
    },

    normalizeSection(section) {
      return {
        userCount: this.pickNumber(section, [
          "userCount",
          "registerUserCount",
          "registeredUserCount",
          "userNum",
          "enrollment",
        ]),
        shopCount: this.pickNumber(section, [
          "shopCount",
          "store",
          "storeCount",
          "countShop",
          "settledShopCount",
        ]),
        merchantCount: this.pickNumber(section, [
          "merchantCount",
          "merchant",
          "countMerchant",
          "ecommerceCount",
          "settledMerchantCount",
        ]),
        uv: this.pickNumber(section, [
          "uv",
          "avgUv",
          "visitorUv",
        ]),
      };
    },

    hasMerchantField(section) {
      if (!section || typeof section !== "object") return false;
      const keys = [
        "merchantCount",
        "merchant",
        "countMerchant",
        "ecommerceCount",
        "settledMerchantCount",
      ];
      return keys.some((key) => Object.prototype.hasOwnProperty.call(section, key));
    },

    pickNumber(obj, keys) {
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (obj && obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
          const num = Number(obj[key]);
          return isNaN(num) ? 0 : num;
        }
      }
      return 0;
    },

    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "0";
      const num = Number(value);
      if (isNaN(num)) return "0";
      return num.toLocaleString();
    },
  },
};
</script>

<style lang="less">
.g-container-box {
  overflow: hidden;
  background: #f5f7fa;
}

.g-header-left {
  background-color: #5c6be8;
  color: #fff;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.g-menu-container {
  height: calc(100vh - 60px);
  background-color: #fff;
  border-right: 1px solid #ebeef5;
}

.g-center-container {
  overflow: auto;
  height: calc(100vh - 60px);
  background-color: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
}

.stats-page {
  min-height: 100%;
}

.stats-tabs {
  background: #fff;
  border-radius: 8px;
  padding: 0 20px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.stats-tabs .el-tabs__header {
  margin: 0;
}

.stats-tabs .el-tabs__nav-wrap::after {
  height: 1px;
  background: #ebeef5;
}

.stats-tabs .el-tabs__item {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #606266;
}

.stats-tabs .el-tabs__item.is-active {
  color: #303133;
  font-weight: 600;
}

.stats-tabs .el-tabs__active-bar {
  background-color: #409eff;
  height: 3px;
}

.overview-card-row {
  margin-top: 20px;
  margin-bottom: 20px;
}

.overview-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 22px 18px;
  display: flex;
  align-items: center;
  min-height: 110px;
  transition: all 0.25s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.overview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.overview-card__icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.icon-bg-0 {
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
}

.icon-bg-1 {
  background: rgba(103, 194, 58, 0.12);
  color: #67c23a;
}

.icon-bg-2 {
  background: rgba(230, 162, 60, 0.12);
  color: #e6a23c;
}

.icon-bg-3 {
  background: rgba(144, 147, 153, 0.12);
  color: #909399;
}

.overview-card__content {
  flex: 1;
}

.overview-card__label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.overview-card__value {
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  line-height: 1.2;
  margin-bottom: 6px;
}

.overview-card__desc {
  font-size: 12px;
  color: #c0c4cc;
}

.table-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 20px;
}

.table-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.table-card__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.table-card__sub {
  font-size: 13px;
  color: #909399;
}

.overview-table {
  width: 100%;
}

.overview-table .el-table__header-wrapper th {
  background: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.overview-table .el-table__body tr:hover > td {
  background: #f8fbff !important;
}

.overview-table .cell {
  padding-left: 12px;
  padding-right: 12px;
}

@media screen and (max-width: 1400px) {
  .overview-card__value {
    font-size: 22px;
  }

  .table-card__header {
    display: block;
  }

  .table-card__sub {
    margin-top: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/a/index.vue